export const SET_ZENDESK_SESSION = 'SET_ZENDESK_SESSION';
export const SET_FILE_UPLOAD_REQUEST_DETAILS = 'SET_FILE_UPLOAD_REQUEST_DETAILS'
export const SET_FILE_CONFIG_DETAILS = 'SET_FILE_CONFIG_DETAILS'